/**
 * Mobile Configuration for Capacitor
 * ตั้งค่าสำหรับ Mobile App
 */

import { Capacitor } from '@capacitor/core'

// ตรวจสอบว่ารันบน Native platform หรือไม่
export const isNative = Capacitor.isNativePlatform()
export const platform = Capacitor.getPlatform() // 'ios', 'android', 'web'

// API Base URL - ใช้ environment variable หรือค่า default
// ตั้งค่าใน .env.production: VITE_MOBILE_API_URL=https://your-api.com/api
const PRODUCTION_API_URL = import.meta.env.VITE_MOBILE_API_URL
  || import.meta.env.VITE_API_URL
  || 'https://hrback.brkinter.synology.me/api'

export const API_BASE_URL = isNative
  ? PRODUCTION_API_URL  // URL สำหรับ Mobile App
  : '/api'  // URL สำหรับ Web (ใช้ proxy)

console.log('🌐 Platform:', platform)
console.log('📱 Is Native:', isNative)
console.log('🔗 API_BASE_URL:', API_BASE_URL)

// ตั้งค่าอื่นๆ สำหรับ Mobile
export const mobileConfig = {
  // Timeout สำหรับ API calls (ms)
  apiTimeout: 30000,

  // Enable/disable features ตาม platform
  features: {
    pushNotifications: isNative,
    camera: isNative,
    geolocation: true,
    haptics: isNative,
    biometrics: isNative
  }
}

// ตรวจสอบว่าควรใช้ Mobile UI หรือไม่
export const shouldUseMobileUI = () => {
  // ถ้าเป็น native app ให้ใช้ Mobile UI เสมอ
  if (isNative) return true

  // ตรวจสอบ URL ว่าอยู่ใน /m/ path หรือไม่
  if (window.location.pathname.startsWith('/m/')) return true

  // ตรวจสอบ localStorage preference
  const preference = localStorage.getItem('preferMobileUI')
  if (preference !== null) return preference === 'true'

  // ตรวจสอบจาก screen size และ touch capability
  const isMobileDevice = (
    window.innerWidth <= 768 &&
    ('ontouchstart' in window || navigator.maxTouchPoints > 0)
  )

  return isMobileDevice
}

// Redirect ไปยัง Mobile UI ถ้าจำเป็น
export const redirectToMobileIfNeeded = (router) => {
  if (shouldUseMobileUI() && !window.location.pathname.startsWith('/m/')) {
    const currentPath = window.location.pathname

    // Map web routes to mobile routes
    const routeMap = {
      '/': '/m/home',
      '/dashboard': '/m/home',
      '/qr-scan': '/m/attendance',
      '/attendance': '/m/attendance',
      '/leave': '/m/leave',
      '/employee/payslips': '/m/payslip',
      '/login': '/m/login'
    }

    const mobilePath = routeMap[currentPath] || '/m/home'
    router.replace(mobilePath)
  }
}

export default {
  isNative,
  platform,
  API_BASE_URL,
  mobileConfig,
  shouldUseMobileUI,
  redirectToMobileIfNeeded
}
